import { createAction, props } from '@ngrx/store';

export const initializeColumnConfigs = createAction('[ColumnConfig] Initialize');

export const loadDefaultColumnConfig = createAction('[DefaultColumnConfig] Load', props<{ gridId: string }>());
export const loadDefaultColumnConfigSuccess = createAction('[DefaultColumnConfig] Load Success', props<{ gridId: string; config: any }>());

export const saveDefaultColumnConfig = createAction('[DefaultColumnConfig] Save', props<{ gridId: string; config: any }>());
export const saveDefaultColumnConfigSuccess = createAction('[DefaultColumnConfig] Save Success', props<{ gridId: string; config: any }>());

export const deleteDefaultColumnConfig = createAction('[DefaultColumnConfig] Delete', props<{ gridId: string }>());
export const deleteDefaultColumnConfigSuccess = createAction('[DefaultColumnConfig] Delete Success', props<{ gridId: string }>());
